import { HTTP } from '@/api/http-shappy-common'
import Vue from 'vue'
import Router from '@/router'
import VueLocalStorage from 'vue-localstorage'

Vue.use(VueLocalStorage)

export const HttpFunctions = {
  response401: () => {
    Router.push({ name: 'Unauthorized' })
  },
  getToken: () => {
    return Vue.localStorage.get('token')
  },
  setToken: (token) => {
    Vue.localStorage.set('token', token)
  },
  getApiBaseUrl: () => {
    return HTTP.defaults.baseURL
  },
  getApiHeaders: () => {
    return HTTP.defaults.headers.common
  },
  getQuota: (key) => {
    return Vue.localStorage.get(key)
  },
  setQuota: (key, quota) => {
    Vue.localStorage.set(key, quota)
  },
  setCountAllProducts: (value) => {
    Vue.localStorage.set('countProducts', value)
  },
  getCountAllProducts: () => {
    return Vue.localStorage.get('countProducts')
  }
}



// WEBPACK FOOTER //
// ./src/api/http-shappy-functions.js